import { Component, Input } from '@angular/core';
import { NguCarouselConfig } from '@ngu/carousel';
import { ICarouselItem } from '../../../models';

@Component({
  selector: 'app-section-promo-tiles',
  templateUrl: './section-promo-tiles.component.html',
  styleUrls: ['./section-promo-tiles.component.scss'],
})
export class SectionPromoTilesComponent {
  @Input() imageHeight: string = '100px';
  @Input() imageBorderRadius: string = '0px';

  @Input() config: NguCarouselConfig;
  @Input() items: ICarouselItem[] = [];

  @Input() showNav = true;
  @Input() showDots = false;

  readonly PLACEHOLDER_COUNT = 4;

  get isCarouselLoading(): boolean {
    return !this.items || !this.items.length;
  }

  get carouselPlaceholders(): any[] {
    return Array(this.PLACEHOLDER_COUNT);
  }
}
